import { StringValidation } from '../../../../utils/component-validations';
import { on } from '@ember/modifier';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/label.gjs';

export default class SpdsInputSearchLabel extends Super {
  arguments = [new StringValidation({ optional: ['for', 'label'] })];
  baseClass = 'spds-input-search-label';

  <template>
    <FlexRow
      @content={{@label}}
      @tag="label"
      class={{this.classes}}
      data-test-spds-input-search-label
      id={{this.id}}
      for={{@for}}
      {{on "click" this.handleClick}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}
